import {testIdProps} from '@github-ui/test-id-props'
import {ToggleSwitch} from '@primer/react'
import {useCallback} from 'react'

import {AgentAssignmentToggleName, ViewOptionsMenuUI} from '../../api/stats/contracts'
import {useAgentAssignmentVisibility} from '../../features/copilot-tasks/use-agent-assignment-visibility'
import {ViewerPrivileges} from '../../helpers/viewer-privileges'
import {usePostStats} from '../../hooks/common/use-post-stats'
import type {BaseViewState, ViewIsDirtyStates} from '../../hooks/use-view-state-reducer/types'
import {PotentiallyDirty} from '../potentially-dirty'
import styles from './hierarchy-toggle.module.css'

export function AgentAssignmentToggle({view}: {view: BaseViewState & ViewIsDirtyStates}) {
  const {hasWritePermissions} = ViewerPrivileges()
  const {agentAssignmentVisible: visible, setAgentAssignmentVisible: setVisible} = useAgentAssignmentVisibility()
  const {postStats} = usePostStats()

  const onClick = useCallback(() => {
    const newValue = !visible
    setVisible(view.number, newValue)
    postStats({
      name: AgentAssignmentToggleName,
      ui: ViewOptionsMenuUI,
      context: newValue ? 'show' : 'hide',
    })
  }, [visible, setVisible, view.number, postStats])

  return (
    <div className={styles.toggleContainer}>
      <PotentiallyDirty
        isDirty={view.isAgentAssignmentVisibleDirty}
        hideDirtyState={!hasWritePermissions}
        {...testIdProps('agent-assignment-dirty')}
      >
        <div id="agent-assignment-visible-label">Show agent sessions</div>
      </PotentiallyDirty>
      <ToggleSwitch size="small" aria-labelledby="agent-assignment-visible-label" checked={visible} onClick={onClick} />
    </div>
  )
}
